export const types = {
    SET_ORIENTATION: "window/set-orientation",
    SET_INFORMATION: "window/set-information",
    OPEN_LOADING: "window/open-loading",
    CLOSE_LOADING: "window/close-loading",
    SHOW_MESSAGE: "window/show-message",
    HIDE_MESSAGE: "window/hide-message",
};

/**
 * Sets the information message displayed on the map.
 *
 * @param message - The information message text.
 * @returns The action object.
 */
export const setInformation = (message) => ({
    type: types.SET_INFORMATION,
    payload: message,
});

/**
 * Sets the current device orientation.
 *
 * @param orientation - The device orientation ("portrait" or "landscape").
 * @returns The action object.
 */
export const setOrientation = (orientation) => ({
    type: types.SET_ORIENTATION,
    payload: orientation,
});

/**
 * Opens the loading overlay with an optional message and type.
 *
 * @param message - The loading overlay message.
 * @param type - The loading overlay type.
 * @returns The action object.
 */
export const openLoading = (message = "", type = "") => ({
    type: types.OPEN_LOADING,
    payload: {
        message,
        type,
    },
});

/**
 * Closes the loading overlay.
 *
 * @returns The action object.
 */
export const closeLoading = () => ({
    type: types.CLOSE_LOADING,
});

/**
 * Displays a toast message with a given type and context.
 *
 * @param message - The toast message text.
 * @param type - The message type (e.g., "info", "error").
 * @param context - The message context scope (e.g., "global").
 * @returns The action object.
 */
export const showMessage = (message, type = "info", context = "global") => ({
    type: types.SHOW_MESSAGE,
    payload: {
        message,
        type,
        context,
    },
});

/**
 * Hides the message displayed for a given context.
 *
 * @param context - The message context to hide.
 * @returns The action object.
 */
export const hideMessage = (context) => ({
    type: types.HIDE_MESSAGE,
    payload: {
        context,
    },
});
